import { render, staticRenderFns } from "./v-language-selector.vue?vue&type=template&id=3ddd1674&scoped=true&"
import script from "./v-language-selector.vue?vue&type=script&lang=js&"
export * from "./v-language-selector.vue?vue&type=script&lang=js&"
import style0 from "./v-language-selector.vue?vue&type=style&index=0&id=3ddd1674&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddd1674",
  null
  
)

export default component.exports